import { Directive } from '@angular/core';

/**
 * Marqueur de style pour les champs de formulaire natifs.
 * Le style associé (.idra-input) est global : src/styles/components/_forms.scss.
 *
 * Usage : <input idraInput type="email" formControlName="email" />
 *         <select idraInput formControlName="type">…</select>
 */
@Directive({
  selector: 'input[idraInput], textarea[idraInput], select[idraInput]',
  host: { class: 'idra-input' },
})
export class IdraInput {}
